import React, {useState} from 'react';
import {Player} from './types';
import {useSwipe} from './useSwipe';

interface Props {
    player: Player;
    handoffLabel: string;
    revealButtonLabel: string;
    hideButtonLabel: string;
    warning?: string;
    content: React.ReactNode;
    onHide: () => void;
}

const SingleReveal: React.FC<Props> = ({
    player,
    handoffLabel,
    revealButtonLabel,
    hideButtonLabel,
    warning,
    content,
    onHide,
}) => {
    const [revealed, setRevealed] = useState(false);
    const handleReveal = () => setRevealed(true);
    const swipe = useSwipe({onSwipeUp: revealed ? onHide : handleReveal, threshold: 70});

    const dragStyle: React.CSSProperties = swipe.dragging
        ? {
            transform: `translateY(${Math.min(0, swipe.offsetY)}px)`,
            opacity: 1 - Math.min(0.5, Math.max(0, -swipe.offsetY) / 260),
            transition: 'none',
        }
        : {transform: 'translateY(0)', opacity: 1};

    if (!revealed) {
        return (
            <div
                className="GmPassCard GmPassCard--swipeable"
                style={dragStyle}
                onTouchStart={swipe.onTouchStart}
                onTouchMove={swipe.onTouchMove}
                onTouchEnd={swipe.onTouchEnd}
            >
                <p className="GmPassCard-hint">{handoffLabel}</p>
                <h2 className="GmPassCard-name">{player.name}</h2>
                <button className="GmBtn GmBtn--primary GmBtn--big" onClick={handleReveal}>
                    {revealButtonLabel}
                </button>
                <p className="GmSwipeHint">▲ или свайпни вверх</p>
            </div>
        );
    }

    return (
        <div
            className="GmPassCard GmPassCard--swipeable"
            style={dragStyle}
            onTouchStart={swipe.onTouchStart}
            onTouchMove={swipe.onTouchMove}
            onTouchEnd={swipe.onTouchEnd}
        >
            {warning && <p className="GmPassCard-warning">{warning}</p>}
            <div className="GmPassCard-content">{content}</div>
            <button className="GmBtn GmBtn--big" onClick={onHide}>{hideButtonLabel}</button>
            <p className="GmSwipeHint">▲ или свайпни вверх</p>
        </div>
    );
};

export default SingleReveal;
